export default __webpack_public_path__ + "static/10-c630a104f5f2fc0b2a8c6b366686437d.jpg";